import { NextResponse } from "next/server";
import { cookies } from "next/headers";
import axios from "axios";
import { BaseURL } from "@/Utils/APIRequest/Endpoints";

export async function POST(req) {

  const cookieStore = await cookies();
  const authToken =
    cookieStore.get("iat")?.value || cookieStore.get("verifyUAT")?.value;
  try {
    const { accessToken } = await req.json();

    const response = await axios.get("https://graph.instagram.com/v21.0/me", {
      params: {
        fields: "followers_count",
      },
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return NextResponse.json({ data: response.data });
  } catch (error) {

    console.error("Error fetching Instagram stats:", error);

    let payload;

    if (error.response) {
      payload = {
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers,
      };
    } else {
      payload = {
        message: error.message,
      };
    }

    let body = {
      module: "instagram_profile_info",
      name: error.response.data.error.type,
      message: error.response.data.error.message,
      context: {
        url: "https://graph.instagram.com/v21.0/me",
        params: {
          fields: "followers_count",
        },
      },
    };

    await axios.post(`${BaseURL}auth/error-log`, body, {
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    });

    return NextResponse.json(
      { error: payload },
      { status: error.response ? error.response.status : 500 }
    );

    // return NextResponse.json(
    //   { error: "Instagram data retrieve failed", details: error.response ? error.response.data : error.message },
    //   { status: 500 }
    // );
  }
}
